import React from "react";
import { TreeLikeData } from "src/types/TreeLikeData";

export const deleteNodeRecursively = <TData extends {}>(
  treeData: TreeLikeData<TData>[],
  key: React.Key,
): TreeLikeData<TData>[] =>
  treeData
    .map((node) => {
      if (node.children && node.children.length > 0) {
        const updatedChildren = deleteNodeRecursively(node.children, key);
        if (updatedChildren.length !== node.children.length) {
          return { ...node, children: updatedChildren };
        }
        return node;
      }
      return node;
    })
    .filter((node) => node.key !== key) as TreeLikeData<TData>[];
